/** @jsx jsx */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React from 'react';
import { jsx, SerializedStyles } from '@emotion/core';

import Icon, { IconType } from 'components/atoms/Icon';
import ReactTooltip, { Place } from 'react-tooltip';

export interface IconTooltipProps {
  iconType: IconType;
  text: string;
  color: string;
  customCss?: SerializedStyles;
  wrapCustomCss?: SerializedStyles;
  place?: ReactTooltip.Place;
}

/**
 * ツールチップのついたアイコン
 */
const IconTooltip: React.FC<IconTooltipProps> = ({
  iconType, text, color, customCss, place = 'top', wrapCustomCss
}) => {
  const rand = 1 + Math.random() * (1 - 10000);
  return (
    <div className="tooltip" css={wrapCustomCss}>
      <a data-tip="true" css={customCss} data-for={`tooltip${rand}`}>
        <Icon type={iconType} color={color} />
      </a>
      <ReactTooltip html={true} id={`tooltip${rand}`} place={place}>
        {text}
      </ReactTooltip>
    </div>
  );
};

export default IconTooltip;
